import ISTable from 'components/lSTable';
import useToken from 'hooks/useToken';
import PrivateLayout from 'layouts/private';
import React from 'react';
import { useQuery } from 'react-query';
import { fetchCapitalsWithReportByCurrency } from 'apiRequest/capitals';

export default function CurrencyBalance() {
  const { token } = useToken();


  const { data: currenciesBalance, isLoading, isError, error } = useQuery("capital-fetchCapitalsWithReportByCurrency", () => {
    return fetchCapitalsWithReportByCurrency({
      token
    });
  });

  const columns = React.useMemo(() => [
    {
      key: 'currency',
      label: 'Currency',
      selector: row => row.currency
    },
    {
      key: 'capital_amount',
      label: 'Capital',
      currency: true,
      selector: row => row.capital_amount,
    },
    {
      key: 'bought_amount',
      label: 'Bought',
      currency: true,
      selector: row => row.bought_amount,
    },
    {
      key: 'sold_amount',
      label: 'Sold',
      currency: true,
      selector: row => row.sold_amount,
    },
    {
      key: 'total_balance',
      label: 'Total Balance',
      currency: true,
      highlight: true,
      selector: row => (row.capital_amount + row.bought_amount) - row.sold_amount,
    },
    {
      key: 'bought_transaction_count',
      label: 'Bought Txn',
      selector: row => row.bought_transaction_count,
    },
    {
      key: 'sold_transaction_count',
      label: 'Sold Txn',
      selector: row => row.sold_transaction_count,
    },
  ], []);

  return (
    <PrivateLayout loading={isLoading} isError={isError} error={error}>
      <ISTable
        title="Currency Balance"
        maxWidth="md"
        size='medium'
        loading={isLoading}
        columns={columns}
        data={currenciesBalance?.data.data}
      />
    </PrivateLayout>
  );
}
